type Translate = (key: string, options?: Record<string, unknown>) => string;

const STATUS_TITLE: Record<string, string> = {
  pending: 'KNOWLEDGE_BASE_PENDING',
  processing: 'KNOWLEDGE_BASE_PROCESSING',
  completed: 'KNOWLEDGE_BASE_COMPLETED',
  failed: 'KNOWLEDGE_BASE_FAILED',
};

const STATUS_BODY: Record<string, string> = {
  pending: 'KNOWLEDGE_BASE_PROCESSING_PENDING',
  processing: 'KNOWLEDGE_BASE_PROCESSING_IN_PROGRESS',
  completed: 'KNOWLEDGE_BASE_PROCESSING_COMPLETED',
  failed: 'KNOWLEDGE_BASE_PROCESSING_FAILED',
};

const STATUS_BODY_REASON: Record<string, string> = {
  pending: 'KNOWLEDGE_BASE_PROCESSING_PENDING_REASON',
  processing: 'KNOWLEDGE_BASE_PROCESSING_IN_PROGRESS_REASON',
  completed: 'KNOWLEDGE_BASE_PROCESSING_COMPLETED_REASON',
  failed: 'KNOWLEDGE_BASE_PROCESSING_FAILED_REASON',
};

/** Backend sends these sentences in English. Returns null when the text is not one of them. */
export function translateKbProcessingText(text: string, translate: Translate): string | null {
  const trimmed = text.trim();
  const chunks = trimmed.match(/^Knowledge base processing completed with (\d+) chunks?\.?$/i);
  if (chunks) {
    return translate('KNOWLEDGE_BASE_PROCESSING_COMPLETED_WITH_CHUNKS', {
      count: Number(chunks[1]),
      defaultValue: 'Knowledge base processing completed with {{count}} chunks.',
    });
  }

  const title = trimmed.match(/^Knowledge base (pending|processing|completed|failed)$/i);
  if (title) {
    return translate(STATUS_TITLE[title[1].toLowerCase()], { defaultValue: trimmed });
  }

  const body = trimmed.match(
    /^Knowledge base processing (pending|processing|completed|failed)(?:\.|: (.+))?$/i
  );
  if (!body) return null;

  const status = body[1].toLowerCase();
  const reason = body[2]?.trim();
  if (reason) {
    return translate(STATUS_BODY_REASON[status], {
      reason,
      defaultValue: `Knowledge base processing ${status}: {{reason}}`,
    });
  }

  return translate(STATUS_BODY[status], {
    defaultValue: `Knowledge base processing ${status}.`,
  });
}
